export type ContractType = 'CDI' | 'CDD' | 'Intérim' | 'Stage' | 'Alternance' | 'Freelance';

export type SalaryPeriod = 'daily' | 'weekly' | 'monthly' | 'annual';

export type SalaryType = 'fixe' | 'fourchette' | 0 | 1;

export interface Job {
  id: number;
  job_title: string;
  description: string;
  business: string;
  business_logo?: string;
  business_phone?: string;
  business_website?: string;
  city: string;
  postal_code: string;
  state?: string;
  contract: ContractType;
  required_experience?: string;
  salary?: number;
  salary_type: SalaryType;
  salary_min: number;
  salary_max?: number;
  salary_period: SalaryPeriod;
  advantages?: string[];
  created_at?: string;
  business_id?: number;
  responsibles_id?: number;
  business_email?: string;
  address_t?: string;
  region?: string;
  active?: boolean;
  promoted?: boolean;
  pubdate?: string;
}

// Map contract types to allowed salary periods
export const CONTRACT_SALARY_PERIODS: Record<ContractType, SalaryPeriod[]> = {
  'CDI': ['daily', 'monthly', 'annual'],
  'CDD': ['daily', 'monthly', 'annual'],
  'Intérim': ['daily', 'weekly', 'monthly'],
  'Stage': ['monthly'],
  'Alternance': ['monthly'],
  'Freelance': ['daily', 'monthly']
};

// List of available job advantages
export const JOB_ADVANTAGES = [
  'Tickets restaurant',
  'Mutuelle',
  'Prévoyance',
  'RTT',
  'Prime annuelle',
  'Prime sur objectifs',
  'Plan d\'épargne entreprise',
  'Participation',
  'Intéressement',
  'Formation',
  'Télétravail partiel',
  'Télétravail total',
  '13ème mois'
];